module.exports = __webpack_public_path__ + "static/media/wN.f9c6e522.svg";